import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckSquare, faSquare } from "@fortawesome/pro-solid-svg-icons";
/** <b>Composant en mode consultation/detail d'un champ de type bool</b>*/
export default function BoolFieldDetail(_a) {
    var fieldName = _a.fieldName, record = _a.record, fieldMetadata = _a.fieldMetadata;
    var value = useMemo(function () {
        if (!record[fieldName]) {
            return;
        }
        return record[fieldName || ""] || "";
    }, [fieldName, record]);
    return (_jsx("span", { children: _jsx(FontAwesomeIcon, { icon: value == 1 ? faCheckSquare : faSquare, className: "flex items-center cursor-not-allowed ".concat(value == 1
                ? "text-[rgb(var(--color-blue-500))]"
                : "border border-black text-white text-xs") }) }));
}
